import { Grid } from '@mui/material'
import Text from 'ui/Element/Text'
import CellHOC from '@platform/react/hoc/list/cell'

const styles = () => ({
  label: {
  },
  article: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
})
/**
 * Displays an article description.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
const ListItemCellPartDescription = (classes, props = {}) => {
  const { name = '-', assemblyLabel, group } = props

  return (
    <Grid
      container
      direction={'column'}
    >
      <Grid
        item
        xs={'auto'}
        component={Text}

        value={name}
        maxLines={1}
        variant={'14/bold'}
        color={'black.main'}
      />
      <Grid
        item
        xs={'auto'}
        component={Text}

        maxLines={1}
        color={'gray.400'}
        variant={'12/regular'}
        value={`${assemblyLabel} • ${group}`}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellPartDescription, styles)
